import {
  Ambulance,
  Briefcase,
  Bug,
  ChefHat,
  Cloud,
  Construction,
  DollarSign,
  Droplet,
  Fan,
  Fence,
  Flame,
  Hammer,
  HeartPulse,
  Home,
  KeyRound,
  Layers,
  PaintRoller,
  Printer,
  Server,
  Scissors,
  Sparkles,
  SprayCan,
  Stethoscope,
  Store,
  Tag,
  Toilet,
  Trees,
  Truck,
  Warehouse,
  WashingMachine,
  Waves,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";

/** Industry category name (lowercased) → icon. */
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  "pest control": Bug,
  "roofing / solar": Home,
  "medical transport": Ambulance,
  "salon suites": Scissors,
  paving: Construction,
  "fireplace / chimney": Flame,
  hvac: Fan,
  "print / marketing": Printer,
  landscape: Trees,
  plumbing: Wrench,
  flooring: Layers,
  "hair restoration": Scissors,
  electric: Zap,
  "epoxy floor": Layers,
  "septic / porta potty": Toilet,
  laundry: WashingMachine,
  "hydration iv services": Droplet,
  fencing: Fence,
  "pool service": Waves,
  "urgent care": HeartPulse,
  "janitorial services": SprayCan,
  "rental arbitrage": KeyRound,
  "med spa": Sparkles,
  "garage door": Warehouse,
  "towing / repair": Truck,
  "kitchen / bath": ChefHat,
  "commercial cleaning": SprayCan,
  "home healthcare": Stethoscope,
  "adu contract": Hammer,
  "niche markets": Store,
  "remodeling/renovation": PaintRoller,
  "software saas": Cloud,
  "msp/it": Server,
};

/** Icon for an industry category name; a briefcase for any category without
 *  its own (new categories, a buyer's free-text "Other"). */
export function industryIcon(name: string): LucideIcon {
  return CATEGORY_ICONS[name.trim().toLowerCase()] ?? Briefcase;
}

/**
 * Pick an icon for a BuyBox tag based on its category. Budget-range tags
 * (e.g. "$3M-$5M") get a dollar sign; unknown tags fall back to a generic tag.
 */
export function buyBoxTagIcon(tag: string): LucideIcon {
  const key = tag.trim().toLowerCase();
  if (CATEGORY_ICONS[key]) return CATEGORY_ICONS[key];
  if (key.includes("$") || key.includes("budget") || /\d\s*m\b/.test(key)) {
    return DollarSign;
  }
  return Tag;
}
